import { FC, useState } from "react";

import { useTranslation } from "react-i18next";

import { useForm } from "@mantine/form";
import { Button, TextInput } from "@mantine/core";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

import { Timeout } from "@components/Timeout/Timeout";
import { FormWithImage } from "@components/FormWithImage/FormWithImage";

export const ForgotPasswordRoute: FC = () => {
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isResendButtonDisabled, setIsResendButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const { onSubmit, getInputProps } = useForm({
    initialValues: {
      email: "",
    },
  });

  const handleSubmit = onSubmit(async ({ email }) => {
    setIsLoading(true);
    await sendPasswordResetEmail(getAuth(), email);
    setIsLoading(false);
    setIsEmailSent(true);
  });

  const title = isEmailSent ? "Check your inbox!" : "Forgot password?";

  return (
    <>
      <FormWithImage
        title={t(title)}
        description={t("Here you can reset your password.")}
        onSubmit={handleSubmit}
      >
        {isEmailSent ? (
          <Timeout
            howLong={10_000}
            onEnd={() => setIsResendButtonDisabled(false)}
          >
            {({ timeLeft, isEnded }) => (
              <Button
                disabled={isResendButtonDisabled}
                onClick={() => {
                  setIsEmailSent(false);
                  setIsResendButtonDisabled(true);
                }}
              >
                {t("Resend Email")}{" "}
                {isEnded ? "" : <>({timeLeft.format("mm:ss")})</>}
              </Button>
            )}
          </Timeout>
        ) : (
          <>
            <TextInput
              required
              type="email"
              label={t("Email Address")}
              {...getInputProps("email")}
            />
            <Button type="submit" loading={isLoading}>
              {t("Reset Password")}
            </Button>
          </>
        )}
      </FormWithImage>
    </>
  );
};
